import { render, staticRenderFns } from "./ListOrganisations.vue?vue&type=template&id=0371321d&scoped=true&"
import script from "./ListOrganisations.vue?vue&type=script&lang=js&"
export * from "./ListOrganisations.vue?vue&type=script&lang=js&"
import style0 from "./ListOrganisations.vue?vue&type=style&index=0&id=0371321d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371321d",
  null
  
)

export default component.exports